import 'font-awesome/css/font-awesome.css';
import 'foundation-sites/dist/css/foundation.min.css';
import 'foundation-datepicker/css/foundation-datepicker.min.css'

//import 'jquery-emoji-picker/css/jquery.emojipicker.css';
//import 'jquery-emoji-picker/css/jquery.emojipicker.g.css';
//import 'emojidex/docs/css/emojidex.min.css';
import 'magnific-popup/dist/magnific-popup.css';
import 'jquery-ui/themes/base/all.css'

// Custom css here
import '../style/default.css';

import jQuery from 'jquery';

window.$ = window.jQuery = jQuery;


import 'jquery-ui/ui/core';
import 'jquery-ui/ui/widgets/dialog';
import 'jquery-ui/ui/widgets/tooltip';
import 'jquery-ui/ui/widgets/datepicker';
import 'jquery-ui/ui/effect.js';


// js-cookies
//import 'jquery-emoji-picker/js/jquery.emojipicker';
//import 'jquery-emoji-picker/js/jquery.emojis';
//import 'emojidex/docs/js/emojidex';
import 'foundation-sites/dist/js/foundation.min.js';
//import 'foundation-datepicker/js/foundation-datepicker.min.js';

//import 'underscore';

//masonry
import 'magnific-popup';

// Custom plugins should be put here
import './lib/app.jquery.fn';

import angular from 'angular';
import uirouter from 'angular-ui-router';
import 'angular-animate';
import 'angular-aria';
import ngMaterial from 'angular-material';

import routing from './routing';

// import translation filter
import translate from './filters/iin8';
import AppController from './features/index/AppController';


// APP FEATURES IMPORTED HERE
import index from './features/index';
import home from './features/home';
import activity from './features/activity';
import search from './features/search';
import swipe from './features/swipe';
import profile from './features/profile';
import inbox from './features/inbox';
import pages from './features/pages';
import feedback from './features/feedback';
import notifications from './features/notifications';
import questions from './features/questions';
import editProfile from './features/edit-profile';
import editMatch from './features/edit-match';
import editSettings from './features/edit-settings';
import photoManager from './features/photo-manager';

let app = () => {
  return {
    template: require('./app.html'),
    controller: 'AppController',
    controllerAs: 'app'
  }
};

const CourtMeNow = 'app';

import panel from './services';

$(document).ready( function () {
  $(document).foundation();
});

angular.module(CourtMeNow, [uirouter, translate, index, home, activity, search, swipe, profile, inbox, pages, feedback, notifications, questions, editProfile, editMatch, editSettings, photoManager, 'panel'])
    .directive('app', app)
    .controller('AppController', AppController)
    .config(routing);

export default CourtMeNow;



// WEBPACK FOOTER //
// ./src/app/app.js